import DDINBase64 from '../../../../../../BaseComponents/Charts/Utils/DDINBase64';

interface IPNGImageConversionResult {
  imageData: string;
  width: number;
  height: number;
}

/**
 *  Returns a promise that resolves into an object with the converted image data and scaled width and height
 *
 * @param svgString
 * @param scaling How much the canvas should scale before rendering to a PNG, can be used to change quality without changing font size
 */
export const convertSvgStringToBase64PNG = (
  svgString: string,
  scaling: number
) =>
  new Promise<IPNGImageConversionResult>((resolve, reject) => {
    const canvas = document.createElement('CANVAS') as HTMLCanvasElement;
    const ctx = canvas.getContext('2d');

    const img = new Image();
    const svg = new Blob([svgString], {
      type: 'image/svg+xml;charset=utf-8',
    });

    const reader = new FileReader();
    reader.readAsDataURL(svg);

    reader.onload = () => {
      img.onload = () => {
        canvas.width = img.width * scaling;
        canvas.height = img.height * scaling;

        if (ctx) {
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        } else {
          reject('No context');
        }

        const imageData = canvas.toDataURL('image/png');

        if (!imageData) {
          reject('Could not get image data');
        }

        resolve({ imageData, width: canvas.width, height: canvas.height });
      };

      if (reader.result && typeof reader.result === 'string') {
        img.src = reader.result;
      } else {
        reject('Reader result is null or not string');
      }
    };
  });

export const preloadDDINFont = () => {
  const tempSvgString = `<svg style="font-family:D-DIN;font-size:12px;"
    xmlns="http://www.w3.org/2000/svg" width="1000" height="600" viewBox="0 0 1000 600">
      <text x="72" y="15">
        Text to load font
      </text>
    <style>@font-face {font-family: "D-DIN";src:url(data:application/font-woff;charset=utf-8;base64,${DDINBase64};}</style>
  </svg>`;
  const svgBlob = new Blob([tempSvgString], {
    type: 'image/svg+xml;charset=utf-8',
  });

  const reader = new FileReader();
  reader.readAsDataURL(svgBlob);
  reader.onload = () => {
    if (reader.result && typeof reader.result === 'string') {
      const img = new Image();
      img.src = reader.result;
    }
  };
};
